import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SEO from "@/components/seo/SEO";

export default function NotFound() {
  const { i18n } = useTranslation();
  const lang = i18n.language || "en";
  return (
    <>
      <SEO title="404" path="/404" />
      <section className="flex min-h-[70vh] items-center justify-center px-6 text-center">
        <div>
          <div className="eyebrow">404</div>
          <h1 className="mt-6 font-serif text-6xl leading-tight tracking-tight sm:text-7xl">Nothing here.</h1>
          <p className="mt-6 text-white/60">The page you're looking for has moved, or never existed.</p>
          <Link to={`/${lang}`} className="mt-8 inline-block text-bht-gold underline underline-offset-4">← Back home</Link>
        </div>
      </section>
    </>
  );
}
